import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import ControlFeedback from "./ControlFeedback";
import { ControlProps } from "./Types";

const NumberControl: React.FC<ControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur }) => {

    function onControlChange(e: ChangeEvent<HTMLInputElement>) {
        if (e.target.value === '')
            onChange(e.target.value);

        var digitRex = /^-?(\d+)?$/;
        if (digitRex.test(e.target.value) === true) {
            onChange(e.target.value);
        }
        else {
            console.log("Not a number: " + e.target.value);
        }
    }

    let v = '';
    if (value != undefined)
        v = value;

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    return (
        <div style={{ width: width }}>
            <Form.Control type='text' name={name} value={v} disabled={disabled} onChange={onControlChange} isInvalid={!isValid} onBlur={onBlur} />
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default NumberControl;